/*
  Scroll reveal (PRD §9). Loaded globally as a module.
  - IntersectionObserver adds .is-visible to [data-reveal] once (CSS in otw-base.css:
    opacity 0 / translateY(16px) → visible over 500ms).
  - Children with [data-reveal-stagger] get a 60ms × index delay (index capped at 8).
  - data-reveal="group" reveals only the staggered children, not the container itself.
  - Picks up elements added later (section re-renders, fetched HTML).
*/
(() => {
  const OTW = (window.OTW = window.OTW || {});
  if (OTW.reveal) return;

  const root = document.documentElement;
  const STEP = 60;
  const MAX_INDEX = 8;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (!('IntersectionObserver' in window) || reduced) {
    const showAll = (scope = document) =>
      scope.querySelectorAll('[data-reveal]').forEach((el) => el.classList.add('is-visible'));
    showAll();
    OTW.reveal = { scan: showAll };
    return;
  }

  root.classList.add('otw-reveal-ready');

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
  );

  function prepare(el) {
    if (el.dataset.revealBound) return;
    el.dataset.revealBound = '';
    el.querySelectorAll('[data-reveal-stagger]').forEach((child, i) => {
      child.style.setProperty('--otw-reveal-delay', `${Math.min(i, MAX_INDEX) * STEP}ms`);
    });
    observer.observe(el);
  }

  function scan(scope = document) {
    if (scope.nodeType !== 1 && scope !== document) return;
    if (scope.matches && scope.matches('[data-reveal]')) prepare(scope);
    scope.querySelectorAll('[data-reveal]').forEach(prepare);
  }

  scan();

  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach((node) => node.nodeType === 1 && scan(node));
    }
  }).observe(document.body, { childList: true, subtree: true });

  OTW.reveal = { scan };
})();
